import _ from 'lodash'

const getCleanedText = (text) => {
  return text.replace('\n\n', '')
}

const getStartCase = (text) => {
  return _.startCase(_.toLower(text))
}

module.exports = {
  getCleanedText,
  getStartCase,
}
